import * as React from "react";
import { forwardRef } from "react";
const SvgGood = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 14 14" ref={ref} {...props}><circle cx={7} cy={7} r={6.75} fill="#fff" stroke="#000" strokeWidth={0.5} /><path stroke="#00A150" d="m4 7 2 2 4.5-4.5" /></svg>;
const ForwardRef = forwardRef(SvgGood);
export default ForwardRef;